import React from 'react';
import PropTypes from 'prop-types';
import {
  createBrowserRouter,
  RouterProvider,
  redirect,
} from 'react-router-dom';
import Posts from './Posts';

const App = ({ path }) => {
  const loader = ({ request }) => {
    const url = new URL(request.url);
    const params = url.searchParams;
    if (params.has('by') && params.has('category')) {
      params.delete('category');
      return redirect(`${url.pathname}?${params.toString()}`);
    }
    return redirect(`${path}page/1${url.search}`);
  };

  const router = createBrowserRouter([
    {
      path,
      loader,
    },
    {
      path: `${path}page/:page`,
      element: <Posts path={path} />,
    },
  ]);

  return <RouterProvider router={router} />;
};

App.propTypes = {
  path: PropTypes.string.isRequired,
};

export default App;
